import React from "react";

export default function IcoAddress() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      class="fill-current"
    >
      <g clip-path="url(#clip0_2888_4302)">
        <path d="M8.5 20C8.33748 20 8.1764 19.948 8.0412 19.8425C5.40059 17.7764 3.66607 16.1406 2.41481 14.5401C0.789594 12.4571 0 10.4205 0 8.31224C0 3.72855 3.81277 0 8.5 0C13.1872 0 17 3.72855 17 8.31224C17 12.8959 13.1354 16.5752 8.9588 19.8425C8.82504 19.948 8.66252 20 8.5 20ZM8.5 1.4346C4.6225 1.4346 1.46701 4.52039 1.46701 8.31224C1.46701 12.1041 4.78934 15.4121 8.5 18.3615C14.6686 13.436 15.533 10.6203 15.533 8.31224C15.533 4.52039 12.3775 1.4346 8.5 1.4346Z" />
        <path d="M8.49973 12.4051C6.19136 12.4051 4.31445 10.5696 4.31445 8.31224C4.31445 6.05485 6.19136 4.21941 8.49973 4.21941C10.8081 4.21941 12.685 6.05485 12.685 8.31224C12.685 10.5696 10.8081 12.4051 8.49973 12.4051ZM8.49973 5.65401C7.00109 5.65401 5.78146 6.8467 5.78146 8.31224C5.78146 9.77778 7.00109 10.9705 8.49973 10.9705C9.99838 10.9705 11.218 9.77778 11.218 8.31224C11.218 6.8467 9.99838 5.65401 8.49973 5.65401Z" />
      </g>
      <defs>
        <clipPath id="clip0_2888_4302">
          <rect width="17" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
